<template>
<div class="sezione versamenti"  >


  <div class="row row-head">
    <div class="col s2 yo-align-left">GIORNO</div>
    <div class="col s3 yo-align-left">IMPORTO</div>
    <div class="col s6 yo-align-left">MEZZO</div>
    <div class="col s1 yo-align-center">
      <!--
      <div style="" class="yo-button small" @click="versamentoAdd()" type="primary" ><i class="material-icons">add</i></div>
      -->
    </div>
  </div>

  
  <div  class="row row-table" v-for="(itm, index) in dbData" v-bind:key="index">
    <div class="col s2 yo-align-left">{{itm.eseguitoil | data('DD-MM-YYYY')}}</div>
    <div class="col s3">{{itm.importo | money('€ ')}}</div>
    <div class="col s6">{{itm.mezzo | items($socio._mezzo,'nome')}}</div>
    <div class="col s1 yo-align-center">
      <a class="yo-button small" @click="sendRicevuta(itm)" style="color:#2E3C4A;padding-right:10px;"><i class="material-icons">email</i></a>
      <a class="yo-button small" @click="printRicevuta(itm)" style="color:#2E3C4A;"><i class="material-icons">print</i></a>
      <!--
      <a class="yo-button small" @click="rowDel(itm)" style="color:#2E3C4A;padding-right:10px;"><i class="material-icons">delete_forever</i></a>
      <router-link class="yo-button small" :to="'/versamento-edit/'+itm.id" style="color:#2E3C4A;"><i class="material-icons">edit</i></router-link>
      -->
    </div>
  </div>


 <!-- 
   <div class="row yo-bg-color-secondary">
      <div class="col s12 m6 title_h1 white" style="margin:0;padding-left:20px;">VERSAMENTI</div>
      <div class="col s12 m6 yo-align-right">
         <div style="margin-right:8px;" class="yo-button white" @click="versamentoAdd()" type="primary" ><i class="material-icons">add</i><div></div></div>
      </div>
   </div>

   <div  v-if="!(dbData.length>0)" class="yo-align-left" style="padding:20px;">Nessun Versamento</div>

   <el-table v-if="dbData.length>0" @cell-mouse-enter="onSelect" @cell-mouse-leave="more=0" :data="dbData" style="width: 100%"  >
   
      <el-table-column sortable prop="id" label="ID" width="80px" header-align="center">
        <template slot-scope="scope">{{ scope.row.id }} </template>
      </el-table-column>


      <el-table-column prop="mezzo" label="MEZZO" align="left" >
        <template slot-scope="scope">{{scope.row.mezzo  | items($socio._mezzo,'nome')}} </template>
      </el-table-column>

      <el-table-column prop="citta" label="IMPORTO" align="left" >
        <template slot-scope="scope">{{scope.row.importo | money('€') }} </template>
      </el-table-column>


      <el-table-column sortable prop="eseguitoil" label="ESEGUITO" width="120px" header-align="center" align="right">
        <template slot-scope="scope">
          <div v-if="(more==scope.row.id)">
          <router-link class="yo-button small" :to="'/versamento-edit/'+scope.row.id" style="color:#2E3C4A;"><i class="material-icons">edit</i></router-link>
          <a class="yo-button small" @click="rowDel(scope.row)" style="color:#2E3C4A;"><i class="material-icons">delete_forever</i></a>
          </div> 
          <div v-if="(more!=scope.row.id)">{{ scope.row.eseguitoil | data('DD-MM-YYYY') }}</div>      
        </template>
      </el-table-column>

    </el-table>
-->


   
</div>
</template>

<script>

import emailRicevuta from './Email-ricevuta.vue'
export default {
  components: {
  },
  created () {
  },
  data () {
    return {
      rowfilter: {cognome:'',nome:'',citta:'',email:''},
       tbstart:0,
       totxpage: 1000,
       more:0,
       order: 'asc',
       icon: 'el-icon-sort-down',
       
    }
  },
  computed:{
    dbData:function(){
        var filterData = []
        if(this.$socio._versamento.length>0)
        for(let item of this.$socio._versamento){
            filterData.push(item)    
        } 
        
        return filterData //.sort(this.$teras.compareValues('cognome',this.order)); 
    }
   },
   methods:{
      async printRicevuta(versamento){
         await this.$axios.query('fetchAll',`SELECT IFNULL(banca.id,'') AS id, IFNULL(banca.importo,0) AS importo,societa.id AS societa,societa.sigla AS sigla,societa.nome AS nome,societa.peso AS peso FROM societa LEFT JOIN banca ON banca.versamento=→versamento AND banca.contatto=→contatto AND banca.societa=societa.id WHERE societa.attivo=1 ORDER BY societa.peso,societa.tipo,societa.sigla,societa.nome`,{versamento:versamento.id,contatto: this.$socio.contatto.row.id},this,'rowBanca')
         var html = this.$teras.renderVue(emailRicevuta,{socio:this.$socio,versamento:versamento,banca:this.rowBanca})

         var mywindow = window.open('', 'Ricevuta', 'height=900,width=800')
         mywindow.document.write('<html><head><title>Ricevuta di pagamento</title>')
         mywindow.document.write('</head><body >')
         mywindow.document.write(html)
         mywindow.document.write('</body></html>')
         //mywindow.document.close(); // necessary for IE >= 10
         //mywindow.focus(); // necessary for IE >= 10*/
         mywindow.print();
         mywindow.close();
      },
      async sendRicevuta(versamento){
         this.loading = this.$loading({lock: true, text: 'Spedizione in corso, non ricaricare la pagina.....', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })
         await this.$socio.sendRicevuta(versamento.id)
         this.loading.close()
         this.$notify.success({type: 'info',message: 'Ricevuta inviata correttamente', duration:5000}) 
     },

      versamentoAdd () {
         this.$router.push('/versamento-edit/')
      },
      rowAction (row,page) {
        console.log(row)
        this.$contatto.row = row
          this.$router.push('/'+page)
      },
      rowDel (row) {
         this.$confirm('Il versamento di '+this.$teras.money(row.importo,'€')+' del '+this.$teras.data(row.eseguitoil)+' verrà eliminato, continuare?', 'Warning', {
            confirmButtonText: 'Si',
            cancelButtonText: 'No',
            type: 'warning'
         }).then(async () => {
            await this.$axios.deleteRow(row.id,'versamento')
            this.$socio.init()
         }).catch(() => {
            this.$message({
               type: 'info',
               message: 'Operazione annullata'
            })         
         })
         
      },
      handleCurrentChange(val) {
         this.tbstart = val*totxpage-totxpage      
         console.log(`current page: ${val}`);
      },
      onSelect(row, event, column){
         this.more=row.id
      },
      onSort(column,event){
         console.log(column)
         this.order = (this.order=='desc') ? 'asc' :'desc'
         this.icon = (this.order=='desc') ? 'el-icon-sort-down' :'el-icon-sort-up'
         this.dbData.sort(this.$teras.compareValues(column.property,this.order))
      },
      labelCol(h, {column}){
         return h('div',{ style: 'color:red;' },[h('b',null,column.label),h('i',{class:this.icon})])
      } 
    
  }
}
</script>


<style scoped>

</style>
